import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimelineElement, TimelineElementStatus, TimelineGroup, TimelineUpdate} from '../timeline.component';

@Component({
  selector: 'app-timeline-element',
  templateUrl: './timeline-element.component.html',
  styleUrls: ['./timeline-element.component.scss']
})
export class TimelineElementComponent implements OnInit {

  @Input()
  group: TimelineGroup

  @Input()
  element: TimelineElement

  @Input()
  canEdit: boolean;

  @Output()
  onUpdate: EventEmitter<TimelineUpdate>

  constructor() {
    this.onUpdate = new EventEmitter<TimelineUpdate>();
  }

  ngOnInit(): void {
  }

  get TimelineElementStatus() { return TimelineElementStatus; }

}
